import { useState } from 'react';
import classnames from 'classnames';

import { useHistory } from 'react-router-dom';

import styles from "./exchange-page.module.sass";
import FormInput from "components/form-input";
import Button from "components/button";
import ButtonDialog from "components/button-dialog";
import { useRedeemCoupon } from "../hooks/use-redeem-coupon";

import { PATH } from 'config';

export function ExchangePage() {
  const [code, setCode] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const { redeemCoupon, isLoading, result, isError } = useRedeemCoupon();
  const history = useHistory();

  const handleCodeChange = (code) => {
    if (!!errorMessage) setErrorMessage('');
    setCode(code);
  };

  const handleSubmit = async () => {
    try {
      if (typeof code !== 'string' || code.length < 1)   {
        throw new Error('此欄位為必填')
      }

      await redeemCoupon(code)
      setCode('')
    } catch (err) {
      const message = err.message;
      if (message) {
        setErrorMessage(message);
      }
      return;
    }
  };

  return (
    <>
      <div className={styles.root}>
        <h3 className={styles.title}>序號兌換</h3>
        <FormInput placeholder="輸入優惠序號" value={code} onTextChanged={handleCodeChange} errorMessage={errorMessage} />
        <Button
          className={classnames({
            [styles.buttonNormal]: errorMessage === '',
            [styles.buttonError]: errorMessage !== '',
          })}
          variant="solid-round"
          onClick={handleSubmit}
          isLoading={isLoading}
        >
          {isLoading ? '兌換中' : '兌換'}
        </Button>
      </div>
      {!isError && !!result  && (
        <ButtonDialog
          isShow={!!result && !isError}
          title="優惠券兌換成功"
          items={[
            {
              content: '前往優惠券',
              theme: 'positive',
              onClick: () => {
                history.push(PATH.COUPON);
              },
            },
          ]}
        >{`恭喜您成功兌換「${result.name}」`}</ButtonDialog>
      )}
    </>
  );
}
